import Vuex, {createLogger} from 'vuex';
import Vue from 'vue';
import app from './app.store';
import metrics from "@/store/modules/metrics";
import user from "@/store/modules/user";
import wineryMetrics from "@/store/modules/wineryMetrics";
import utils from "@/store/modules/utils";
import survey from "@/store/modules/survey";
import help from "@/store/modules/help";


Vue.use(Vuex)

const store = new Vuex.Store({
    debug: false,
    modules: {
        app,
        user,
        metrics,
        wineryMetrics,
        utils,
        survey,
        help
    },
    plugins: [createLogger(),
        store => {
            store.subscribe((mutation, state) => {
                localStorage.setItem('vuex', JSON.stringify(state))
            })
        }
    ]
})

console.log("Restoring state")
const savedState = localStorage.getItem('vuex')
if (savedState) {
    const restored = JSON.parse(savedState);
    if (restored.help) restored.help.inflight = [];
    store.replaceState(Object.assign({}, store.state, restored))
}


window.addEventListener('storage', function(e) {
    if (e.key === 'help:invalidate' && e.newValue) {
        try {
            var payload = JSON.parse(e.newValue);
            store.commit('help/INVALIDATE_CACHE', payload.key);
            store.dispatch('help/fetchByKey', payload.key);
        } catch (_) {}
    }
});

export default store
